export default __webpack_public_path__ + "static/media/lost.cca09c7c.mp3";